module.exports = __webpack_public_path__ + "img/SL.64eee651.svg";